/**
 * The commerce ladder's actions as DATA (SA-464, the SA-461 review's
 * deferred minor): which "move to the next rung" buttons a record offers.
 * Read by the record lane's strip (`RecordStrip`) and the form frame's
 * Actions card (`OrderDetail`) — each renders its own `<Button>` markup, so
 * the frame's bytes never move (`OrdersPage.frame.test.tsx`). E4 (spec
 * D26): every move INTO the commerce ladder is commerce, so without the
 * flag there is nothing to offer. Edit and Cancel are not rungs and stay
 * at their sites.
 */
import type { Order } from '@/types/commerce'

export interface LadderAction { status: string; label: string }

export function ladderActions(order: Pick<Order, 'status' | 'depositCents' | 'depositPaid'>, showCommerce: boolean): LadderAction[] {
  if (!showCommerce) return []
  const actions: LadderAction[] = []
  if (order.status === 'quoted') actions.push({ status: 'pending_payment', label: 'Send Payment Link' })
  if (order.status === 'pending_payment' && order.depositCents > 0 && !order.depositPaid) actions.push({ status: 'deposit_paid', label: 'Mark Deposit Paid' })
  if (order.status === 'pending_payment' || order.status === 'deposit_paid') actions.push({ status: 'fully_paid', label: 'Mark as Paid' })
  if (order.status === 'fully_paid') actions.push({ status: 'in_production', label: 'Start Production' })
  if (order.status === 'in_production') actions.push({ status: 'ready', label: 'Mark Ready' })
  if (order.status === 'ready') actions.push({ status: 'delivered', label: 'Mark Delivered' })
  return actions
}
